import React from 'react';
import { Spin } from 'antd';

const TheSpinner: React.FC = () => {
    return (
        <div className='tail-h-full tail-flex tail-flex-col tail-justify-center tail-items-center'>
                <Spin />
        </div> 
    );
};

export default TheSpinner;